// import React from "react";
// import { motion } from "framer-motion";

// const HeroSection = () => {
//   return (
//     <div className="relative w-full h-screen overflow-hidden bg-gradient-to-b from-sky-100 to-blue-300 flex items-center justify-center">
//       {/* Background Mountain */}
//       <img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Mountain.png"
//         alt="Mountain"
//         className="absolute bottom-0 w-full h-screen object-cover z-0"
//       />

//       {/* Clouds from Left to Right */}
//       {/* <motion.img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Cloud-Top_Left.png"
//         alt="Cloud Left Top"
//         className="absolute top-10 left-0 w-[250px] opacity-80"
//         animate={{ x: ["-10%", "110%"] }}
//         transition={{ repeat: Infinity, duration: 60, ease: "linear" }}
//       />

//       <motion.img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Cloud-Bottom_Left.png"
//         alt="Cloud Left Bottom"
//         className="absolute bottom-28 left-0 w-[300px] opacity-80"
//         animate={{ x: ["-20%", "120%"] }}
//         transition={{ repeat: Infinity, duration: 80, ease: "linear" }}
//       /> */}

//       {/* Clouds from Right to Left */}
//       {/* <motion.img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Cloud-Top_Right.png"
//         alt="Cloud Right Top"
//         className="absolute top-20 right-0 w-[260px] opacity-80"
//         animate={{ x: ["10%", "-120%"] }}
//         transition={{ repeat: Infinity, duration: 70, ease: "linear" }}
//       />

//       <motion.img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Cloud-Bottom_Right.png"
//         alt="Cloud Right Bottom"
//         className="absolute bottom-40 right-0 w-[320px] opacity-80"
//         animate={{ x: ["20%", "-130%"] }}
//         transition={{ repeat: Infinity, duration: 90, ease: "linear" }}
//       /> */}

//       {/* Aircraft Animation */}
//       <motion.img
//         src="https://mhcockpit.com/Media/4%20Aviators/Home/Aircraft.png"
//         alt="Aircraft"
//         className="absolute top-10 w-[180px] z-20"
//         initial={{ x: 500, y: 200, opacity: 0 }}
//         animate={{ x: -400, y: 500, opacity: 1 }}
//         transition={{ duration: 5, ease: "easeInOut" }}
//       />

//       {/* Text Content */}
//       <motion.div
//         className="relative z-30 text-center max-w-xl px-6"
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 1.8, ease: "easeOut", delay: 1 }}
//       >
//         <h1 className="text-3xl md:text-5xl font-bold text-[#012D6F]">
//           Excellence in Flight Training, Grounded in Safety
//         </h1>
//         <p className="text-lg md:text-xl leading-relaxed">
//           Learn from seasoned instructors in a program built around precision,
//           discipline, and safety the true foundations of every great pilot.
//         </p>
//       </motion.div>
//     </div>
//   );
// };

// export default HeroSection;




import React from "react";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <section
      className="relative w-full h-screen bg-cover bg-center flex items-start justify-center text-center pt-20"
      style={{
        backgroundImage:
          "url('https://mhcockpit.com/Media/4%20Aviators/Home/Mountain.png')",
      }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>

      {/* Content */}
      <motion.div
        className="relative z-10 px-6 sm:px-10 max-w-3xl"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#012D6F] leading-snug">
          Excellence in Flight Training, <br className="hidden sm:block" /> 
          Grounded in Safety
        </h1>

        <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-700">
          Learn from seasoned instructors in a program built around precision, 
          discipline, and safety the true foundations of every great pilot.
        </p>
      </motion.div>
    </section>
  );
};

export default HeroSection;
